<script lang="ts">
	import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
	import { isProSensorAddon } from 'src/helpers/addons/addon_support_helpers';
	import ControlOnOffAddon from './ControlOnOffAddon.svelte';
	import ControlOnOff from './ControlOnOff.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let status: any;
	export let settings: any;

	let peripheral = getAddonStatus(device, [], false, true);
</script>

{#if isProSensorAddon(device) && peripheral.find((i) => i.peripheralType == 'switch')}
	<div class="d-flex gap-s">
		<div class="control-flex-column">
			<ControlOnOffAddon
				{device}
				{status}
				isInSlot
				component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor?.component}
			/>
		</div>
		<div class="control-flex-column">
			<ControlOnOff {device} {status} {settings} isInSlot />
		</div>
	</div>
{:else}
	<ControlOnOff {device} {status} {settings} isWide />
{/if}

<style>
	.control-flex-column {
		flex: 1;
	}
</style>
